/**
 * Author: Ben Quackenbush
 * Description: Adds a click handler to the Yotpo star ratings widget that scrolls to the reviews widget.
 * Date: 2026-04-20
 * Note: This is a bit of a workaround. Yotpo's built in scroll to function does not seem to be working at the moment, and this is a simple way to add the functionality back in without needing to wait for a fix from Yotpo.
 * If Yotpo fixes their scroll to function, this file and the related code in snippets/scripts.liquid can be removed.
 * Should be screen reader accessible, and respects the user's prefers-reduced-motion setting.
 */

const starWidgetId = 'yotpo-reviews-star-ratings-widget';
const starWidgetButtonClass = 'yotpo-sr-bottom-line-button';
const reviewsWidgetId = 'yotpo-reviews-main-widget';

let isBound = false;

const bindReviewsScroll = () => {
  if (isBound) return;

  const starWidget = document.getElementById(starWidgetId);
  const reviewsWidget = document.getElementById(reviewsWidgetId);

  if (!starWidget || !reviewsWidget) return;
  const button = starWidget.querySelector(`.${starWidgetButtonClass}`);
  if (!button) return;
  /** @param {MouseEvent} event */
  const clickHandler = (event) => {
    event.preventDefault();
    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches;

    reviewsWidget.scrollIntoView({
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
      block: 'start',
    });
    if (!reviewsWidget.hasAttribute('tabindex')) {
      reviewsWidget.setAttribute('tabindex', '-1');
    }

    reviewsWidget.focus({ preventScroll: true });
  };
  button.addEventListener('click', clickHandler);
  isBound = true;
};

const addScrollToReviews = () => {
  bindReviewsScroll();
  if (isBound) return;
  const observer = new MutationObserver(() => {
    bindReviewsScroll();
    if (!isBound) return;
    observer.disconnect();
  });
  const mainContent = document.getElementById('MainContent');
  if (mainContent) {
    observer.observe(mainContent, {
      childList: true,
      subtree: true,
    });
  } else {
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }
  setTimeout(() => {
    observer.disconnect();
  }, 20000); // Stop watching after 20 seconds, just in case.
};

addScrollToReviews();
